import { render, staticRenderFns } from "./wageTable.vue?vue&type=template&id=4e3ce93e&scoped=true&"
import script from "./wageTable.vue?vue&type=script&lang=js&"
export * from "./wageTable.vue?vue&type=script&lang=js&"
import style0 from "./wageTable.vue?vue&type=style&index=0&id=4e3ce93e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e3ce93e",
  null
  
)

export default component.exports